import { Box } from "@chakra-ui/react";
import { Score } from "@keita/lanepatrol-sdk";

interface Props {
  score: Score;
}
export const TreatmentScoreBubble: React.FC<Props> = ({ score }) => {
  return (
    <Box
      display="inline-table"
      bg={score.global.color}
      borderRadius={4}
      width={12}
      height={5}
      flexShrink={0}
      fontSize="sm"
      textAlign="center"
    >
      {score.global.value.toFixed(2)}
    </Box>
  );
};
